import axios from 'axios';
import { cachetime } from '../config';

export default function() {
  return {
    namespaced: true,
    state: {
      borderCheckpoints: {},
    },
    mutations: {
      SET_BORDERCHECKPOINTS(state, { data, locale }) {
        state.borderCheckpoints = {
          ...state.borderCheckpoints,
          [locale]: {
            data,
            __updatedAt: Date.now(),
          }
        }
      }
    },
    actions: {
      FETCH_BORDERCHECKPOINTS({ state, commit }, { locale }) {
        if (state.borderCheckpoints[locale] 
          && state.borderCheckpoints[locale].data
          && Date.now() - state.borderCheckpoints[locale].__updatedAt < cachetime
        ) {
          return ;
        }

        return axios.get('/api/border-checkpoints')
          .then((res) => {
            const data = res.data || {};
            commit('SET_BORDERCHECKPOINTS', { data, locale});
          }).catch(err => console.log(err));
      }
    },
    getters: {
      getBorderCheckpoints: (state) => (locale) => {
        return state.borderCheckpoints[locale] ? state.borderCheckpoints[locale].data || {} : {};
      }
    }
  }
};